import { render, staticRenderFns } from "./CommonCategoryList.vue?vue&type=template&id=4fcb84d8&scoped=true&"
import script from "./CommonCategoryList.vue?vue&type=script&lang=js&"
export * from "./CommonCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CommonCategoryList.vue?vue&type=style&index=0&id=4fcb84d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb84d8",
  null
  
)

export default component.exports